import React from "react";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/system";

const StyledAvatar = styled(Avatar, {
  shouldForwardProp: prop => prop !== "bgColor" && prop !== "fontColor"
})(({ theme, bgColor, fontColor }) => ({
  background: bgColor || "#fff",
  color: fontColor,
  fontSize: "16px",
  fontWeight: 400,
  width: "32px",
  height: "32px",
  marginRight: "16px",
  [theme.breakpoints.up("sm")]: {
    fontSize: "24px",
    width: "54px",
    height: "54px"
  }
}));

export const ColoredAvatar = ({ color, textColor, children }) => {
  return (
    <StyledAvatar bgColor={color} fontColor={textColor} data-testid="default-avatar-icon">
      {children}
    </StyledAvatar>
  );
};
